// 从环境变量中读取基础 URL
const BASE_URL = process.env.VUE_APP_API_BASE_URL;
const WS_URL = process.env.VUE_APP_WS_BASE_URL;

export { BASE_URL, WS_URL };

// 具体 API 路径拼接
export const GET_USER_INFO_API = BASE_URL + "images/";
export const GET_WEB_SOCKET_API = WS_URL; 